import { render, staticRenderFns } from "./LayoutError.vue?vue&type=template&id=0bc77d38&scoped=true&"
import script from "./LayoutError.vue?vue&type=script&lang=js&"
export * from "./LayoutError.vue?vue&type=script&lang=js&"
import style0 from "./LayoutError.vue?vue&type=style&index=0&id=0bc77d38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc77d38",
  null
  
)

export default component.exports